var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("width:" + _vm.width + ";height:" + _vm.height + ";"))},[_c('iframe',{attrs:{"src":_vm.iframeUrl,"frameborder":"0","width":"100%","height":"100%","allowtransparency":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }